import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_API_URL } from '@cnt-workspace/data-access';
import { INewsletterSubscriptionStatus, IUser } from '@curbnturf/entities';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'notification-settings/newsletter';

/** A user's newsletter (Mailchimp) subscription: read, change, or add them to the list. */
@Injectable({ providedIn: 'root' })
export class AdminNewsletterApiService {
  private readonly http = inject(HttpClient);

  /** `GET …/newsletter/:userId`; 404 when they aren't on the list. */
  getStatus(userId: number): Observable<INewsletterSubscriptionStatus> {
    return this.http.get<INewsletterSubscriptionStatus>(`${API_URL}/${userId}`);
  }

  /** `PUT …/newsletter`; 404 when they aren't on the list. */
  setStatus(userId: number, status: 'subscribed' | 'unsubscribed'): Observable<INewsletterSubscriptionStatus> {
    return this.http.put<INewsletterSubscriptionStatus>(API_URL, { status, user: { id: userId } });
  }

  /** `POST …/newsletter`: adds them to the list; 409 when they're already on it. */
  add(user: Pick<IUser, 'email' | 'firstName' | 'lastName'>): Observable<INewsletterSubscriptionStatus> {
    return this.http.post<INewsletterSubscriptionStatus>(API_URL, {
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
    });
  }
}
